import { BRAND_CLASSES } from '@/constants/theme';
/**
 * Get consistent label classes based on size.
 * - 'xs': Panel-style labels (text-xs uppercase tracking-wide, muted color, mb-1)
 * - 'sm' / 'md': Modal-style labels (text-sm font-medium, standard color, mb-2)
 */
export function getLabelClasses(labelSize = 'sm', labelClassName = '') {
    const size = labelSize === 'xs' ? 'text-xs uppercase tracking-wide' : 'text-sm';
    const weight = labelSize === 'xs' ? '' : 'font-medium';
    const color = labelSize === 'xs' ? 'text-slate-500 dark:text-slate-400' : BRAND_CLASSES.INPUT.LABEL;
    const margin = labelSize === 'xs' ? 'mb-1' : 'mb-2';
    return `block ${size} ${weight} ${color} ${margin} ${labelClassName}`.trim();
}
